export const MATERIAL_GROUP_EXPORT_ID = 'material-group';

export const MATERIAL_GROUP_TITLE = 'Grupos de Materiales';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  type: 'Tipo',
  company: 'Compañia',
  division: 'División',
  hasSubcategories: 'Subcategorías',
  statusId: 'Estado',

};
